<template>
  <div class="form-overview">
    <p><strong>Formularz:</strong> {{ form.formName }}</p>
    <p><strong>Projekt:</strong> {{ form.projectName }}</p>
    <div v-bind:key="fieldName" v-bind:item="input" v-for="(input, fieldName) in form.inputs">
      <fieldset>
        <legend>{{ input.name }}</legend>
        <p><strong>Typ: </strong>{{ inputTypeText(input.type) }}</p>
        <p><strong>Nagłówek: </strong>{{ input.options.label }}</p>
        <p><strong>Placeholder: </strong><span v-if="input.options.placeholder">{{ input.options.placeholder }}</span><i v-else>--brak--</i></p>
      </fieldset>
      <br/>
    </div>
  </div>
</template>
<script>

import formHelper from './formHelper'

export default {
  props: ['form'],
  data () {
    return {}
  },
  name: 'c-form-overview',
  methods: {
    ruleText (rule) {
      return formHelper.ruleText(rule)
    },
    inputTypeText (type) {
      return formHelper.inputTypeText(type)
    }
  }
}
</script>
